<template>
    <div class="w-full flex items-start gap-x-5">
        <div class="rounded-lg min-w-[30%] bg-white p-10 text-black">
            <h2 class="text-2xl font-extralight underline">Remplir les champs suivants :</h2>
            <form @submit.prevent="saveForm" class="mt-8">
                <div class="w-full flex flex-col items-start ">
                    <label for="name" class="font-light" >Nom<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.nom" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                </div>
                <div class="w-full flex flex-col items-start ">
                    <label for="prenom" class="font-light" >Prenom<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.prenom" name="prenom" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="Doe">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="poste" class="font-light" >Poste<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.poste" placeholder="" name="poste" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="debut" class="font-light" >Date de départ<span class="text-[#f44545]">*</span></label>
                    <input type="date" v-model="form.debut" placeholder="" name="debut" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="fin" class="font-light" >Date de reprise<span class="text-[#f44545]">*</span></label>
                    <input type="date" v-model="form.reprise" placeholder="" name="fin" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="ambassade" class="font-light" >Pays ambassade<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.contry" placeholder="" name="ambassade" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                    <button type="submit" :disabled="asSend" class="w-full mt-8 py-3 bg-[#5357ec] text-white rounded-md">
                        <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                        <span v-if="!asSend">Enregistrer</span>
                    </button>
            </form>
        </div>
        <div class="rounded-lg grow min-h-[850px] bg-white">
            <div class="mx-auto w-[89%] rounded-lg px-7 py-8 mt-10">
                <div class="w-full flex justify-center mt-14 mb-20">
                    <img src="../../../../assets/uigb-logo.png" alt="logo uigb" class="h-20 w-auto object-cover">
                </div>
                <div class="flex justify-center">
                    <h2 class="text-4xl font-semibold text-center text-black bg-[#e5e5e5] px-16 py-6 border-2 mt-44 mb-20 border-black inline-block rounded-xl">ATTESTATION DE CONGES</h2>
                </div>

                <p class="text-gray-700 mb-10 text-2xl">
                    Nous soussignés, International University of Grand-Bassam (IUGB), BP 564 Grand-Bassam, Côte d’Ivoire attestons que <span class="font-bold">{{ form.nom ?? "TITLE NAME" }} {{ form.prenom ?? "" }}</span>, <span class="font-bold">{{ form.poste ?? "POSITION" }}</span> , sera en congés annuels du <span class="font-bold">{{ form.debut ?? "LEAVE PERIOD" }}</span> inclus.
                </p>

                <p class="mb-10 text-gray-700 text-2xl">
                    Elle/il reprendra normalement le service le <span class="font-bold">{{ form.reprise ?? "RESUMPTION DATE" }}</span> aux horaires habituels.
                </p>

                <p class="mb-16 text-gray-700 text-2xl">
                    En foi de quoi, nous lui délivrons la présente attestation pour soutenir sa demande de visa auprès de l’ambassade de <span class="font-bold">{{ form.contry ?? "COUNTRY" }}</span> en Côte d’Ivoire.
                </p>

                <div class="text-right text-2xl">
                    <p class="text-gray-700 mb-32">Fait à Abidjan le <span class="font-bold">DATE</span></p>
                    <p class="text-gray-700 mr-32 font-bold">SIGNATURE</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {Loader2} from "lucide-vue-next";
import API from "@/service/API";
import toast from "@/components/ui/toast";
export default {
    name: "AttestConge",
    components: {Loader2},
    data() {
        return {
            asSend: false,
            form: {
                nom: null,
                prenom: null,
                poste: null,
                debut:null,
                reprise: null,
                contry: null,
            }
        };
    },
    methods: {
        clearForm() {
            this.form.nom = null;
            this.form.prenom = null;
            this.form.poste = null;
            this.form.debut = null;
            this.form.reprise = null;
            this.form.contry = null;
        },
        saveForm(){
            this.asSend = true;
            const data = {
                "content" : JSON.stringify(this.form),
                "doc_id":15,
                "user_id": localStorage.getItem("userId") ?? this.$store.getters.userId
            }
            API.post("user-docs", data)
                .then((response) => {
                    if(response.data["status"] == 'success'){
                        toast.success("Succès","Demande enregistré avec succès",4000)
                        this.clearForm();
                    }else{
                        toast.error("Oops..",response.data["message"],4000)
                    }
                })
                .catch(() => {
                    toast.error("Oops..","Il semble avoir une erreur, merci de réessayé.",4000)
                }).finally(()=>{
                    this.asSend = false;
                });
        }
    },
}
</script>